/**
 * Three dots that fade in sequentially after a verb-form label on
 * any aria-busy CTA. Pattern: "Signing in...", "Creating account...",
 * "Verifying...". Pure CSS via three .mio-cta-dot spans with
 * staggered animation-delay.
 *
 * Render inside a CTA only when `flow.submitting` is true. The verb
 * label comes from the caller; this component is just the dots.
 */

"use client";

export function EllipsisDots() {
  return (
    <>
      <span className="mio-cta-dot mio-cta-dot-1" aria-hidden="true">
        .
      </span>
      <span className="mio-cta-dot mio-cta-dot-2" aria-hidden="true">
        .
      </span>
      <span className="mio-cta-dot mio-cta-dot-3" aria-hidden="true">
        .
      </span>
    </>
  );
}
